import environment from '../../environment';
import { allVehicleTypes } from './constants';
import { getFAIcon } from '../../../utils';

const api = () => require('../../api/index').default;
let timeoutUpdateVehicleType;

const getClientVehicleTypes = () => getConfig().VEHICLETYPES || [];
const getChosenVehicleType = () => getConfig().USERVEHICLETYPE;
const setChosenVehicleType = value => getConfig().USERVEHICLETYPE = value;
const getIconButton = () => $('#trigger-vehicle-type i');
const getConfig = () => environment.get("CONFIG");

export const enableVehicleType = () => {
    const iconButton = $('#trigger-vehicle-type');

    const lengthVehicles = getClientVehicleTypes().length;
    if(lengthVehicles <= 1)
        return;

    iconButton.show();
    const handleClickVehicleType = lengthVehicles === 2 ? toggleIcon : openOptionsVehicleType;
    iconButton.on('click', handleClickVehicleType);
    updateIconVehicleType();
};

const openOptionsVehicleType = () => {
    toggleIcon();
    //todo open a pop up to choose vehicle type
};

const toggleIcon = () => {
    const iconButton = getIconButton();
    allVehicleTypes.forEach(({icon}) => iconButton.removeClass(getFAIcon(icon)));
    const vehicleTypes = getClientVehicleTypes();
    const position = vehicleTypes.indexOf(getChosenVehicleType()) + 1;
    const idVehicleType = vehicleTypes[position % vehicleTypes.length];
    updateIconVehicleType(idVehicleType);

    clearTimeout(timeoutUpdateVehicleType);
    timeoutUpdateVehicleType = setTimeout(() => api().management.update.user.vehicleType(idVehicleType), 1000);
};

const updateIconVehicleType = (idVehicle = getChosenVehicleType()) => {
    const vehicleType = allVehicleTypes.find(x => x.id === idVehicle);
    getIconButton().addClass(getFAIcon(vehicleType.icon));
    setChosenVehicleType(idVehicle);
};



// WEBPACK FOOTER //
// ./src/scripts/core/vehicleType/index.js